import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetTargetPageNamePageUseCase extends UseCase {
  constructor({mapper, service}) {
    super({mapper, service})

    this._mapper = mapper
    this._service = service
  }

  async execute({path}) {
    const {targetPage} = this._mapper.map({path})
    const response = targetPage && (await this._service.execute({path: targetPage}))
    return {targetPage: response && response.pageName}
  }
}
